import React from 'react';
import { useLocation } from 'react-router-dom';
import { CtaSessionIcon, MdOutlineArrowRightAlt } from '../../icons';
// import ctaCardBg from './images/graph.png';
import queryString from 'query-string';
import './css/style.scss';

const CtaCardV12 = ({ data, onClickCallback, isSubscribed }) => {
  const { pathname, search } = useLocation();
  const { id } = queryString.parse(search);
  return (
    <div className="w-100 ctaCardV12Box bg-white position-relative overflow-hidden shadow rounded-3">
      {/* <img src={ctaCardBg} className="ctaCardBoxBg object-fit-cover w-100 h-100 float-start" /> */}
      <svg id="Layer_1" data-name="Layer 1" viewBox="0 0 2636.66 900.84" className="ctaCardBoxBg">
        <defs>
          <linearGradient
            id="linear-gradient"
            x1="1318.35"
            y1="-2.02"
            x2="1307.63"
            y2="908.6"
            gradientUnits="userSpaceOnUse"
          >
            <stop offset="0" stop-color="#43b1e5" />
            <stop offset="1" stop-color="#5381c2" />
          </linearGradient>
          <linearGradient
            id="linear-gradient-2"
            x1="1106.04"
            y1="-72.92"
            x2="1080.81"
            y2="985.26"
            gradientUnits="userSpaceOnUse"
          >
            <stop offset="0" stop-color="#46baeb" />
            <stop offset="1" stop-color="#538dca" />
          </linearGradient>
          <linearGradient
            id="linear-gradient-3"
            x1="870.25"
            y1="-71.73"
            x2="870.25"
            y2="1062.23"
            gradientUnits="userSpaceOnUse"
          >
            <stop offset="0" stop-color="#5cc7f2" />
            <stop offset="1" stop-color="#4191ce" />
          </linearGradient>
        </defs>
        <path
          d="M1773.71,900.84s48.12-143.11,329.82-199.65c0,0,241.21-38.87,338.14-174.33,0,0,64.24-93.05,69.88-265,0,0,3.38-176.66,125.11-261.84H0V899.25Z"
          fill="url(#linear-gradient)"
        />
        <path
          d="M1368.81,900s109.87-162.28,360.09-221.26c0,0,335.32-61.79,424.36-204.48,0,0,92.43-113.47,20.29-305.59,0,0-23.55-86.65,10.26-168.67H0V899.25Z"
          fill="url(#linear-gradient-2)"
        />
        <path
          d="M1047.69,900.84S1009.24,644,1321.45,614.51c0,0,271.63-19,376.46-185.48,0,0,76.64-104.33,24.31-287.08,0,0-23.32-82.93,17.25-141.95H0V899.25Z"
          fill="url(#linear-gradient-3)"
        />
      </svg>
      <div className="ctaCardBoxIn d-flex justify-content-between align-items-center">
        <div className="ctaCardDetails text-start">
          <h4 className="fs-3 text-white fw-semibold mb-3 position-relative">
            Thank you, for reserving the session.
          </h4>
          <h6 className="fs-4 fw-medium text-white mb-4">Interested in similar sessions?</h6>
          <button
            className="btn fs-4 btn-light fw-medium rounded-3 cursorPointer ctaLink d-inline-flex align-items-center gap-2"
            disabled={isSubscribed}
            onClick={() =>
              onClickCallback(
                data?.id,
                data?.cta_type_id,
                data?.entity_id,
                data?.session_id,
                3,
                pathname,
                id
              )
            }
          >
            {isSubscribed ? 'Subscribed' : 'Subscribe Now'}{' '}
            <MdOutlineArrowRightAlt customClass={'fs-2'} />
          </button>
        </div>
        <div className="ctaCardIcon">
          <CtaSessionIcon />
        </div>
      </div>
    </div>
  );
};

export default React.memo(CtaCardV12);
